import {rgba} from "polished"

import mainTheme from "@irati/ui/src/global/theme"

const letters = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
]

const colors: string[] = [
  mainTheme.colors.primary1_200,
  mainTheme.colors.secondary1_200,
  mainTheme.colors.tertiary.g_200,
  mainTheme.colors.tertiary.v_200,
  mainTheme.colors.tertiary.b_200,
  mainTheme.colors.tertiary.j_200,
  mainTheme.colors.tertiary.i_200,
  mainTheme.colors.tertiary.f_200,
  mainTheme.colors.tertiary.p_200,
  mainTheme.colors.tertiary.r_200,
  mainTheme.colors.tertiary.o_200,
  mainTheme.colors.tertiary.y_200
]

export default (name: string, deactivated = false): string => {
  const index = name ? letters.findIndex((letter) => (letter === name.charAt(0).toLowerCase())) : 0
  const number = index >= 0 ? index % colors.length : 0
  const color = colors[number]

  return rgba(color, deactivated ? 0.5 : 1)
}
